import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface DashboardKpiStripProps {
  children: ReactNode;
  className?: string;
}

/** Centers KPI pills in a wrapping row at the top of a dashboard tab (Zenith / Figma KPI row).
 *
 * Below the `mobile` breakpoint (≤570px) the strip switches to a horizontal
 * scroller (`scrollbar-hide`) so 4+ KPI tiles do not wrap into tall stacks
 * that push the dashboard content down. From `mobile` upwards it returns to
 * the centred wrap layout used by every dashboard tab.
 */
export function DashboardKpiStrip({ children, className }: DashboardKpiStripProps) {
  return (
    <div
      className={cn(
        "flex w-full justify-start overflow-x-auto scrollbar-hide mobile:justify-center mobile:overflow-visible",
        className,
      )}
    >
      <div className="flex min-w-max items-center gap-1.5 mobile:min-w-0 mobile:flex-wrap mobile:justify-center sm:gap-3">
        {children}
      </div>
    </div>
  );
}
